module.exports = __webpack_public_path__ + "static/img/guanjun_2.02e6762.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/guanjun_2.png
// module id = XolM
// module chunks = 1